import {
  LCL_PACKAGE_DESTINATION_ID,
  LCL_PACKAGE_IDS,
} from "global/constants";

type ShouldApplyLclPackageRestrictionParams = {
  typeLoad?: string | null;
  destinationId?: number | null;
};

type ShouldDisableLclPackageOptionParams =
  ShouldApplyLclPackageRestrictionParams & {
    packageId?: number | null;
  };

export const shouldApplyLclPackageRestriction = ({
  typeLoad,
  destinationId,
}: ShouldApplyLclPackageRestrictionParams) => {
  return (
    typeLoad === "LCL" &&
    destinationId === LCL_PACKAGE_DESTINATION_ID &&
    LCL_PACKAGE_DESTINATION_ID !== null &&
    LCL_PACKAGE_IDS.length > 0
  );
};

export const shouldDisableLclPackageOption = ({
  typeLoad,
  destinationId,
  packageId,
}: ShouldDisableLclPackageOptionParams) => {
  if (
    !shouldApplyLclPackageRestriction({
      typeLoad,
      destinationId,
    })
  ) {
    return false;
  }

  return LCL_PACKAGE_IDS.includes(packageId ?? -1);
};
